"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const constants_1 = require("../constants");
const CitrusBanner_1 = __importDefault(require("../components/CitrusBanner/CitrusBanner"));
const KevelBanner_1 = __importDefault(require("../components/KevelBanner/KevelBanner"));
const CitrusAnalytics_1 = __importDefault(require("../components/CitrusAnalytics/CitrusAnalytics"));
const KevelAnalytics_1 = __importDefault(require("../components/KevelAnalytics/KevelAnalytics"));
const KevelBannerPreviewer_1 = __importDefault(require("../components/KevelBannerPreviewer/KevelBannerPreviewer"));
const bannerDataElem = document.getElementById(constants_1.BANNER_DATA_ELEM_ID);
const previewerDataElem = document.getElementById(constants_1.BANNER_PREVIEWER_DATA_ELEM_ID);
if (bannerDataElem) {
    const esiRootElem = document.getElementById(constants_1.BANNER_ROOT_ELEM_ID);
    const data = JSON.parse(bannerDataElem.textContent || "{}");
    if (esiRootElem) {
        if (data.associatedAdvertId) {
            const isKevelBanner = data.clickUrl && data.impressionUrl;
            if (isKevelBanner) {
                (0, client_1.hydrateRoot)(esiRootElem, react_1.default.createElement(KevelBanner_1.default, Object.assign({}, data)));
            }
            else {
                (0, client_1.hydrateRoot)(esiRootElem, react_1.default.createElement(CitrusBanner_1.default, Object.assign({}, data)));
            }
        }
        else {
            (0, client_1.hydrateRoot)(esiRootElem, react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(CitrusAnalytics_1.default, null),
                react_1.default.createElement(KevelAnalytics_1.default, null)));
        }
    }
}
else if (previewerDataElem) {
    const previewerRootElem = document.getElementById(constants_1.BANNER_PREVIEWER_ROOT_ELEM_ID);
    const data = JSON.parse(previewerDataElem.textContent || "{}");
    if (previewerRootElem) {
        (0, client_1.hydrateRoot)(previewerRootElem, react_1.default.createElement(KevelBannerPreviewer_1.default, Object.assign({}, data)));
    }
}
